export default "/images/vendor/flag-icon-css/flags/4x3/ua.svg?67a46bf793e26237ace0ff44b2eff6b6";